import { render, staticRenderFns } from "./ModalMediaEdit.vue?vue&type=template&id=04f107f2&scoped=true"
import script from "./ModalMediaEdit.vue?vue&type=script&lang=js"
export * from "./ModalMediaEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalMediaEdit.vue?vue&type=style&index=0&id=04f107f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f107f2",
  null
  
)

export default component.exports